import { ANDLogo } from './and/ANDLogo';
import { andBrandColors } from './and/andBrandColors';
import { andFontFamily } from './and/andFontFamily';
import { LBGLogo } from './lbg/LBGLogo';
import { lbgFontFamily } from './lbg/lbgFontFamily';
import { lbgBrandColors } from './lbg/lbgBrandColors';
import { Logo } from '../icons/Logo/Logo';
import { defaultBrandColors } from '../themes/defaultBrandColors';
import { defaultFontFamily } from '../themes/defaultFontFamily';
import { mcalisterBrandColors } from './mcalister/mcalisterBrandColors';
import { mcalisterFontFamily } from './mcalister/mcalisterFontFamily';
import { McalisterLogo } from './mcalister/McalisterLogo';
import { calculateAroundTheWorldDestination } from './challenges/aroundTheWorld/calculateAroundTheWorldDestination';
import { calculateAndDestination } from './challenges/andChallenge/calculateAndDestination';
import { LBG_CHALLENGE_DETAILS } from './lbg/lbgChallengeDetails';
import { AND_CHALLENGE_DETAILS } from './and/andChallengeDetails';
import { DEFAULT_CHALLENGE_DETAILS } from './defaultChallengeDetails';

export const brandOverride = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'lbg':
      return {
        brandColors: lbgBrandColors,
        fontFamily: lbgFontFamily,
        logo: <LBGLogo />,
        calculateDestination: calculateAroundTheWorldDestination,
        ...LBG_CHALLENGE_DETAILS,
      };
    case 'and':
      return {
        brandColors: andBrandColors,
        fontFamily: andFontFamily,
        logo: <ANDLogo />,
        calculateDestination: calculateAndDestination,
        ...AND_CHALLENGE_DETAILS,
      };
    case 'mcalister':
      return {
        brandColors: mcalisterBrandColors,
        fontFamily: mcalisterFontFamily,
        logo: <McalisterLogo />,
        calculateDestination: calculateAroundTheWorldDestination,
        ...DEFAULT_CHALLENGE_DETAILS,
      };
    default:
      return {
        brandColors: defaultBrandColors,
        fontFamily: defaultFontFamily,
        logo: <Logo />,
        calculateDestination: calculateAroundTheWorldDestination,
        ...DEFAULT_CHALLENGE_DETAILS,
      };
  }
};
